module.exports = __webpack_public_path__ + "img/airstep.0c8fbcd3.jpg";